export const validation = {
  titleError: 'Please enter valid first name.',
  displayError: 'Please enter valid last name.',
  fullName: 'First name is required',
  lastName: 'Last name is required',
  maxFullName: 'First name must not be greater than 29 characters',
  maxLastName: 'Last name must not be greater than 29 characters',
};
